import React from "react";
import { Grid } from "../../UI/Grid";
import { MUILabelCheckbox } from "../../UI/MUILabelCheckbox";


interface IProps {
  handleCheckboxSelection: (e: any) => void;
  checkboxes: {
    [k: string]: boolean
  } 
  type?: string;
}

const TOOLTIP_TEXTS: {[k: string]: any} = {
    residentInfoData: {
      title: "Resident identification data",
      text: "This will include: Last Name, First Name, Import System Id, Import System Lease Number, Renewal Status, Email, Unit Type, and Gender Options.",
    },
    includeQuickJoinInfo: {
      title: 'QuickJoin Link',
      text: 'This will include Quick Join/Registration Link for each resident.',
    },
    includeRegistrationInfo: {
      title: 'Registration data',
      text: 'This will include: Import date, whether resident is registered, Registration date, Registration method, whether it is a RoomSync Gained Lease.',
    },
    includeSocialAccountsInfo: {
      title: 'Social Accounts',
      text: "This will include resident’s links to social media: Twitter, Instagram, Snapchat, Youtube, Pinterest, Tiktok. If provided.",
    },
    includeRoommatesInfo: {
      title: 'Roommates',
      text: "This will include the resident’s roommate’s first name, last name, email, and whether they knew their roommate before joining RoomSync.",
    },
    includeHousingInfo: {
      title: 'Housing options',
      text: 'This will include housing options selected by resident.',
    },
    includeMajorsInfo: {
      title: 'Majors',
      text: 'This will include majors selected by resident.',
    },
    includeLifestyleQuestionInfo: {
      title: 'Lifestyle questions',
      text: "This will include the resident’s bio as well as their answers to lifestyle questions about themselves and their ideal roommate.",
    },

    roommatesRelationsData: { // RMM
      title: 'Roommates relations',
      text: 'This will include: last name, first name, unit type and information which users have selected who to be in a same room.',
    },
    residentIdentificationDetails: { // RMM
      title: 'Resident Identification Details',
      text: 'This will include email, information if user has registered, unique id and lease id.',
    },
    residentProfileDetails: { // RMM
      title: 'Resident Profile Details',
      text: 'This will include: room type, information if resident is new or renewal, gender options.',
    },
    matchingDetails: { // RMM
      title: 'Matching Details',
      text: 'This will include: information if the match is locked, matching source and date of the latest matching relation modification',
    }

  };
  

export const ReportCheckboxes = (props: IProps) => <>
  {Object.keys(TOOLTIP_TEXTS).map((key) => 
    (key === "residentInfoData" && !props.type) || (key === "roommatesRelationsData" && props.type === "RMM")?
    <Grid item>
      <MUILabelCheckbox 
        label={TOOLTIP_TEXTS[key].title}
        tooltipContent={TOOLTIP_TEXTS[key]}
        isChecked
        disabled
      />
    </Grid>:
    (props.checkboxes[key] !== undefined && <Grid item>
      <MUILabelCheckbox 
        label={TOOLTIP_TEXTS[key].title}
        name={key}
        isChecked={props.checkboxes[key]}
        onChange={props.handleCheckboxSelection}
        tooltipContent={TOOLTIP_TEXTS[key]}
      />
    </Grid>
  ))}
</>;